



// import React, { useEffect, useState } from "react";
// import {
//   getPendingProjects,
//   approveProject,
// } from "../../../services/ProjectReqservice";
// import "./ProjReq.css";

// function ProjectRequests() {
//   const [projects, setProjects] = useState([]);
//   const [selectedProject, setSelectedProject] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [approvingId, setApprovingId] = useState(null);
//   const [search, setSearch] = useState("");
//   const [error, setError] = useState("");

//   useEffect(() => {
//     fetchProjects();
//   }, []);

//   const fetchProjects = async () => {
//     try {
//       setLoading(true);
//       const data = await getPendingProjects();
//       setProjects(data || []);
//     } catch (err) {
//       setError(err.message || "Failed to load projects");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleApprove = async (projectId) => {
//     try {
//       setApprovingId(projectId);

//       await approveProject(projectId);

//       setProjects((prev) =>
//         prev.filter((project) => project.id !== projectId)
//       );

//       if (
//         selectedProject &&
//         selectedProject.id === projectId
//       ) {
//         setSelectedProject(null);
//       }
//     } catch (err) {
//       alert(err.message || "Failed to approve project");
//     } finally {
//       setApprovingId(null);
//     }
//   };

//   const filteredProjects = projects.filter((project) => {
//     const ownerName =
//       `${project.owner.first_name} ${project.owner.last_name}`.toLowerCase();

//     return (
//       project.name.toLowerCase().includes(search.toLowerCase()) ||
//       ownerName.includes(search.toLowerCase()) ||
//       project.owner.email
//         .toLowerCase()
//         .includes(search.toLowerCase())
//     );
//   });

//   if (loading) {
//     return (
//       <div className="project-requests-page">
//         <div className="project-request-header">
//           <div>
//             <h1>Project Requests</h1>
//             <p>Loading pending requests...</p>
//           </div>
//         </div>

//         <div className="project-request-loading-grid">
//           {[1, 2, 3, 4].map((item) => (
//             <div
//               className="project-request-skeleton"
//               key={item}
//             />
//           ))}
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="project-requests-page">
//       {/* HEADER */}
//       <div className="project-request-header">
//         <div>
//           <h1>Project Requests</h1>
//           <p>
//             Manage and approve pending project requests
//           </p>
//         </div>

//         <div className="project-request-stats">
//           <div className="request-stat-card">
//             <h2>{projects.length}</h2>
//             <span>Pending Requests</span>
//           </div>
//         </div>
//       </div>

//       {/* SEARCH */}
//       <div className="project-request-toolbar">
//         <input
//           type="text"
//           placeholder="Search project, owner, email..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="project-search-input"
//         />
//       </div>

//       {/* ERROR */}
//       {error && (
//         <div className="project-request-error">
//           {error}
//         </div>
//       )}

//       {/* EMPTY */}
//       {!loading && filteredProjects.length === 0 && (
//         <div className="project-empty-state">
//           <h3>No Pending Projects</h3>
//           <p>
//             All projects are approved. Nothing pending.
//           </p>
//         </div>
//       )}

//       {/* PROJECT LIST */}
//       <div className="project-request-grid">
//         {filteredProjects.map((project) => (
//           <div
//             className="project-request-card"
//             key={project.id}
//           >
//             {/* TOP */}
//             <div className="project-card-top">
//               <div className="project-avatar-wrapper">
//                 {project.logo_url ? (
//                   <img
//                     src={project.logo_url}
//                     alt={`${project.name} logo`}
//                     className="project-avatar"
//                   />
//                 ) : (
//                   <div className="project-avatar-fallback">
//                     {project.name.charAt(0).toUpperCase()}
//                   </div>
//                 )}
//               </div>

//               <div className="project-basic-info">
//                 <h3>{project.name}</h3>
//                 <span className="pending-badge">
//                   Pending Approval
//                 </span>
//               </div>
//             </div>

//             {/* BODY */}
//             <div className="project-card-body">
//               <div className="project-detail-item">
//                 <span>Owner</span>
//                 <p>
//                   {project.owner.first_name}{" "}
//                   {project.owner.last_name}
//                 </p>
//               </div>

//               <div className="project-detail-item">
//                 <span>Email</span>
//                 <p>{project.owner.email}</p>
//               </div>

//               <div className="project-detail-item">
//                 <span>Base URL</span>
//                 <p>{project.base_url}</p>
//               </div>

//               <div className="project-detail-item">
//                 <span>Requested</span>
//                 <p>
//                   {new Date(
//                     project.request_date
//                   ).toLocaleString()}
//                 </p>
//               </div>

//               {/* CONFIGS */}
//               <div className="project-configs-section">
//                 <span className="config-heading">
//                   Templates
//                 </span>

//                 <div className="config-chip-container">
//                   {project.configs?.length > 0 ? (
//                     project.configs.map((config) => (
//                       <div
//                         key={config.id}
//                         className="config-chip"
//                       >
//                         <div
//                           className="config-color-dot"
//                           style={{
//                             background:
//                               config.primary_color,
//                           }}
//                         />

//                         <span>
//                           {config.template_name}
//                         </span>
//                       </div>
//                     ))
//                   ) : (
//                     <span className="no-config-text">
//                       No Configurations
//                     </span>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* ACTIONS */}
//             <div className="project-card-actions">
//               <button
//                 className="view-project-btn"
//                 onClick={() =>
//                   setSelectedProject(project)
//                 }
//               >
//                 View Details
//               </button>

//               <button
//                 className="approve-project-btn"
//                 disabled={
//                   approvingId === project.id
//                 }
//                 onClick={() =>
//                   handleApprove(project.id)
//                 }
//               >
//                 {approvingId === project.id
//                   ? "Approving..."
//                   : "Approve"}
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* MODAL */}
//       {selectedProject && (
//         <div
//           className="project-modal-overlay"
//           onClick={() =>
//             setSelectedProject(null)
//           }
//         >
//           <div
//             className="project-modal"
//             onClick={(e) =>
//               e.stopPropagation()
//             }
//           >
//             <button
//               className="close-modal-btn"
//               onClick={() =>
//                 setSelectedProject(null)
//               }
//             >
//               ×
//             </button>

//             <div className="project-modal-header-with-logo">
//               <div className="modal-header-avatar-container">
//                 {selectedProject.logo_url ? (
//                   <img 
//                     src={selectedProject.logo_url} 
//                     alt={`${selectedProject.name} Brand Mark`} 
//                     className="modal-project-logo-image" 
//                   />
//                 ) : (
//                   <div className="modal-project-logo-fallback">
//                     {selectedProject.name.charAt(0).toUpperCase()}
//                   </div>
//                 )}
//               </div>
//               <div className="modal-header-title-text">
//                 <h2>{selectedProject.name}</h2>
//                 <span className="pending-badge">
//                   Pending Approval
//                 </span>
//               </div>
//             </div>

//             <div className="project-modal-content">
//               <div className="modal-info-grid">
//                 <div>
//                   <span>Owner</span>
//                   <p>
//                     {
//                       selectedProject.owner
//                         .first_name
//                     }{" "}
//                     {
//                       selectedProject.owner
//                         .last_name
//                     }
//                   </p>
//                 </div>

//                 <div>
//                   <span>Email</span>
//                   <p>
//                     {
//                       selectedProject.owner
//                         .email
//                     }
//                   </p>
//                 </div>

//                 <div>
//                   <span>Base URL</span>
//                   <p>
//                     {
//                       selectedProject.base_url
//                     }
//                   </p>
//                 </div>

//                 <div>
//                   <span>Status</span>
//                   <p>
//                     {
//                       selectedProject.status
//                     }
//                   </p>
//                 </div>

//                 <div>
//                   <span>Requested At</span>
//                   <p>
//                     {new Date(
//                       selectedProject.request_date
//                     ).toLocaleString()}
//                   </p>
//                 </div>
//               </div>

//               <div className="modal-config-section">
//                 <h4>Project Configurations</h4>

//                 <div className="modal-config-grid">
//                   {selectedProject.configs?.map(
//                     (config) => (
//                       <div
//                         key={config.id}
//                         className="modal-config-card"
//                       >
//                         <div
//                           className="config-preview-color"
//                           style={{
//                             background:
//                               config.primary_color,
//                           }}
//                         />

//                         <h5>
//                           {
//                             config.template_name
//                           }
//                         </h5>

//                         <span>
//                           {
//                             config.design_name
//                           }
//                         </span>

//                         <small>
//                           {
//                             config.channel_type
//                           }
//                         </small>
//                       </div>
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 className="approve-project-btn"
//                 disabled={
//                   approvingId ===
//                   selectedProject.id
//                 }
//                 onClick={() =>
//                   handleApprove(
//                     selectedProject.id
//                   )
//                 }
//               >
//                 {approvingId ===
//                 selectedProject.id
//                   ? "Approving..."
//                   : "Approve Project"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default ProjectRequests;


import React, { useEffect, useState } from "react";
import {
  getPendingProjects,
  approveProject,
} from "../../../services/ProjectReqservice";
import "./ProjReq.css";
import { toast } from "react-toastify";


function ProjectRequests() {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [approvingId, setApprovingId] = useState(null);
  const [search, setSearch] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const data = await getPendingProjects();
      setProjects(data || []);
    } catch (err) {
      setError(err.message || "Failed to load projects");
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (projectId) => {
    try {
      setApprovingId(projectId);

      await approveProject(projectId);

      setProjects((prev) =>
        prev.filter((project) => project.id !== projectId)
      );

      if (
        selectedProject &&
        selectedProject.id === projectId
      ) {
        setSelectedProject(null);
      }
    } catch (err) {
      toast.error(err.message || "Failed to approve project");
    } finally {
      setApprovingId(null);
    }
  };

  const filteredProjects = projects.filter((project) => {
    const ownerName =
      `${project.owner.first_name} ${project.owner.last_name}`.toLowerCase();

    return (
      project.name.toLowerCase().includes(search.toLowerCase()) ||
      ownerName.includes(search.toLowerCase()) ||
      project.owner.email
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  });

  if (loading) {
    return (
      <div className="project-requests-page">
        <div className="project-request-header">
          <div>
            <h1>Project Requests</h1>
            <p>Loading pending requests...</p>
          </div>
        </div>

        <div className="project-request-loading-grid">
          {[1, 2, 3, 4].map((item) => (
            <div
              className="project-request-skeleton"
              key={item}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="project-requests-page">
      {/* HEADER */}
      <div className="project-request-header">
        <div>
          <h1>Project Requests</h1>
          <p>
            Manage and approve pending project requests
          </p>
        </div>

        <div className="project-request-stats">
          <div className="request-stat-card">
            <h2>{projects.length}</h2>
            <span>Pending Requests</span>
          </div>
        </div>
      </div>

      {/* SEARCH */}
      <div className="project-request-toolbar">
        <input
          type="text"
          placeholder="Search project, owner, email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="project-search-input"
        />
      </div>

      {/* ERROR */}
      {error && (
        <div className="project-request-error">
          {error}
        </div>
      )}

      {/* EMPTY */}
      {!loading && filteredProjects.length === 0 && (
        <div className="project-empty-state">
          <h3>No Pending Projects</h3>
          <p>
            All projects are approved. Nothing pending.
          </p>
        </div>
      )}

      {/* PROJECT LIST */}
      <div className="project-request-grid">
        {filteredProjects.map((project) => (
          <div
            className="project-request-card"
            key={project.id}
          >
            {/* TOP */}
            <div className="project-card-top">
              <div className="project-avatar-wrapper">
                {project.logo_url ? (
                  <img
                    src={project.logo_url}
                    alt={`${project.name} logo`}
                    className="project-avatar"
                  />
                ) : (
                  <div className="project-avatar-fallback">
                    {project.name.charAt(0).toUpperCase()}
                  </div>
                )}
              </div>

              <div className="project-basic-info">
                <h3>{project.name}</h3>
                <span className="pending-badge">
                  Pending Approval
                </span>
              </div>
            </div>

            {/* BODY */}
            <div className="project-card-body">
              <div className="project-detail-item">
                <span>Owner</span>
                <p>
                  {project.owner.first_name}{" "}
                  {project.owner.last_name}
                </p>
              </div>

              <div className="project-detail-item">
                <span>Email</span>
                <p>{project.owner.email}</p>
              </div>

              <div className="project-detail-item">
                <span>Base URL</span>
                <p>{project.base_url}</p>
              </div>

              <div className="project-detail-item">
                <span>Requested</span>
                <p>
                  {new Date(
                    project.request_date
                  ).toLocaleString()}
                </p>
              </div>

              {/* CONFIGS */}
              <div className="project-configs-section">
                <span className="config-heading">
                  Templates
                </span>

                <div className="config-chip-container">
                  {project.configs?.length > 0 ? (
                    project.configs.map((config) => (
                      <div
                        key={config.id}
                        className="config-chip"
                      >
                        <div
                          className="config-color-dot"
                          style={{
                            background:
                              config.primary_color,
                          }}
                        />

                        <span>
                          {config.template_name}
                        </span>
                      </div>
                    ))
                  ) : (
                    <span className="no-config-text">
                      No Configurations
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* ACTIONS */}
            <div className="project-card-actions">
              <button
                className="view-project-btn"
                onClick={() =>
                  setSelectedProject(project)
                }
              >
                View Details
              </button>

              <button
                className="approve-project-btn"
                disabled={
                  approvingId === project.id
                }
                onClick={() =>
                  handleApprove(project.id)
                }
              >
                {approvingId === project.id
                  ? "Approving..."
                  : "Approve"}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* MODAL */}
      {selectedProject && (
        <div
          className="project-modal-overlay"
          onClick={() =>
            setSelectedProject(null)
          }
        >
          <div
            className="project-modal"
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            <button
              className="close-modal-btn"
              onClick={() =>
                setSelectedProject(null)
              }
            >
              ×
            </button>

            <div className="project-modal-header-with-logo">
              <div className="modal-header-avatar-container">
                {selectedProject.logo_url ? (
                  <img 
                    src={selectedProject.logo_url} 
                    alt={`${selectedProject.name} Brand Mark`} 
                    className="modal-project-logo-image" 
                  />
                ) : (
                  <div className="modal-project-logo-fallback">
                    {selectedProject.name.charAt(0).toUpperCase()}
                  </div>
                )}
              </div>
              <div className="modal-header-title-text">
                <h2>{selectedProject.name}</h2>
                <span className="pending-badge">
                  Pending Approval
                </span>
              </div>
            </div>

            <div className="project-modal-content">
              <div className="modal-info-grid">
                <div>
                  <span>Owner</span>
                  <p>
                    {
                      selectedProject.owner
                        .first_name
                    }{" "}
                    {
                      selectedProject.owner
                        .last_name
                    }
                  </p>
                </div>

                <div>
                  <span>Email</span>
                  <p>
                    {
                      selectedProject.owner
                        .email
                    }
                  </p>
                </div>

                <div>
                  <span>Base URL</span>
                  <p>
                    {
                      selectedProject.base_url
                    }
                  </p>
                </div>

                <div>
                  <span>Status</span>
                  <p>
                    {
                      selectedProject.status
                    }
                  </p>
                </div>

                <div>
                  <span>Requested At</span>
                  <p>
                    {new Date(
                      selectedProject.request_date
                    ).toLocaleString()}
                  </p>
                </div>
              </div>

              <div className="modal-config-section">
                <h4>Project Configurations</h4>

                <div className="modal-config-grid">
                  {selectedProject.configs?.map(
                    (config) => (
                      <div
                        key={config.id}
                        className="modal-config-card"
                      >
                        <div
                          className="config-preview-color"
                          style={{
                            background:
                              config.primary_color,
                          }}
                        />

                        <h5>
                          {
                            config.template_name
                          }
                        </h5>

                        <span>
                          {
                            config.design_name
                          }
                        </span>

                        <small>
                          {
                            config.channel_type
                          }
                        </small>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="approve-project-btn"
                disabled={
                  approvingId ===
                  selectedProject.id
                }
                onClick={() =>
                  handleApprove(
                    selectedProject.id
                  )
                }
              >
                {approvingId ===
                selectedProject.id
                  ? "Approving..."
                  : "Approve Project"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProjectRequests;